var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Subdominios"}},[(_vm.chartSeries.length > 0)?_c('vue-apex-charts',{attrs:{"type":"pie","id":"subdomain-chart","height":"800","options":_vm.chartOptions,"series":_vm.chartSeries}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }